import React, { FC, SyntheticEvent, useCallback, useState } from "react";

import {
  Button,
  Checkbox,
  Column,
  FormCheckWrapper,
  FormLabel,
  Link,
  Row,
  Typography,
  TextInput,
} from "../../../components";

export interface INewsLetterFormBody {
  privacy: boolean;
  email: string;
}

export interface INewsLetterLinks {
  policy: string;
  terms: string;
}

export interface INewsLetterSubscriptionProps {
  links?: INewsLetterLinks;
  onSubmitForm: (body: INewsLetterFormBody) => void;
  joinTitle?: string;
  joinDescription?: string;
}

const NewsLetterSubscriptionForm: FC<INewsLetterSubscriptionProps> = ({
  links,
  joinTitle,
  joinDescription,
  onSubmitForm,
}) => {
  const [emailValue, setEmailValue] = useState("");
  const [buttonEnabled, setbuttonEnabled] = useState(true);

  const gotSubscribed = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();

    const { privacy, email } = event.currentTarget;

    onSubmitForm({
      privacy: (privacy as HTMLInputElement)?.checked ?? false,
      email: (email as HTMLInputElement)?.value ?? "",
    });
  };

  const emailOnChange = useCallback((e) => {
    setEmailValue(e.target.value);
  }, []);

  const handleCheckbox = useCallback(() => {
    setbuttonEnabled((state) => !state);
  }, []);

  return (
    <div className="py-9 px-6 pt-lg-11 pb-lg-10 px-lg-0 border-widget">
      <Row justifyContent="justify-content-center">
        <Column xs={12} lg={4}>
          <form action="#" onSubmit={gotSubscribed}>
            <Typography
              classes={{ root: "mb-6" }}
              variant="mobile-header-20-bold"
              as="div"
            >
              {joinTitle}
            </Typography>
            <Typography classes={{ root: "mb-8 " }} variant="p-medium" as="div">
              {joinDescription}
            </Typography>
            <div className="mb-7 mb-lg-6">
              <TextInput
                onChange={emailOnChange}
                value={emailValue}
                label="Email"
                name="email"
                placeholder="name@example.com"
                type="email"
                required
                autoComplete="email"
              />
            </div>
            <FormCheckWrapper classes={{ root: "mb-8" }}>
              <Checkbox
                id="privacy"
                name="privacy"
                required
                onChange={handleCheckbox}
              />

              <FormLabel
                htmlFor="privacy"
                className=""
                classes={{
                  root: "text-desc fw-medium form-check-label--grey",
                }}
              >
                I have read and accept{" "}
                <Link href={links?.policy ?? "#"} variant="inline">
                  Privacy Policy
                </Link>{" "}
                and{" "}
                <Link href={links?.terms ?? "#"} variant="inline">
                  Terms & Conditions
                </Link>
              </FormLabel>
            </FormCheckWrapper>
            <Button
              variant="primary"
              type="submit"
              disabled={!emailValue || buttonEnabled}
            >
              Subscribe
            </Button>
          </form>
        </Column>
      </Row>
    </div>
  );
};

export default NewsLetterSubscriptionForm;
